import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  LOCALE_ID,
  OnInit,
} from '@angular/core';
import { ProductListFascade } from '../../fascades/product-list.fascade';
import { map } from 'rxjs/operators';

@Component({
  selector: 'orderform-guarantee-seal',
  templateUrl: './guarantee-seal.component.html',
  styleUrls: ['./guarantee-seal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuaranteeSealComponent implements OnInit {
  @Input() art: 'gold' | 'blue';
  lang: string = this.locale.split('-')[0]; // de / en / etc
  refund_days$ = this._productListFascade.settings$.pipe(
    map((settings) => settings.refund_days)
  );

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private _productListFascade: ProductListFascade
  ) {}

  ngOnInit(): void {}
}
